import React from 'react';
import { useContext } from 'react';
import constants from '../../../common/constants';
import { ContentViewerContext } from '../ContentViewerContext';
import { ContentPagesTree } from './ContentPagesTree';
import { Container, Header } from '@amzn/awsui-components-core';

export const ContentPageNavigation = () => {
  const { isEditingEnabled, content, currentPage, changeCurrentPage } =
    useContext(ContentViewerContext);
  if (isEditingEnabled) {
    return (
      <div>
        <Container
          data-testid="pageNav"
          header={<Header variant="h3">{constants.CONTENT_PAGE_NAVIGATION_HEADER}</Header>}
        >
          <ContentPagesTree
            // @ts-expect-error TS2322 - strict migration
            content={content}
            nodeClassName="navigation-item"
            selectedNodeClassName="navigation-selected"
            selectedNode={currentPage}
            onSelectedNodeChanged={changeCurrentPage}
            showRootNode
          />
        </Container>
      </div>
    );
  } else {
    return (
      <div data-testid="pageNav">
        <ContentPagesTree
          // @ts-expect-error TS2322 - strict migration
          content={content}
          nodeClassName="navigation-item"
          selectedNodeClassName="navigation-selected"
          selectedNode={currentPage}
          onSelectedNodeChanged={changeCurrentPage}
          showRootNode
        />
      </div>
    );
  }
};
